// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__clRap","errorLogs":"EditorFooter_errorLogs__3TRJG"};